
export const NotFoundScreen = () => {
    return (<div className="py-5">
        <div className="text-center mb-3 mt-2">
            <h2>Tento odkaz není funkční</h2>        
            <p>Zřejmě máte špatný odkaz.</p>
        </div>
    </div>)
}